"use client";

import { GoogleMapsProvider } from "@/utils/google-maps-context";
import { CookieProvider } from "@/app/[lng]/_components/cookie-provider";
import { LocaleContext } from "@/app/i18n/client";
import { TooltipProvider } from "@/components/ui/tooltip";
import { type LocaleName } from "@/app/i18n/settings";
import { RequestCookie } from "@/types/next-cookies";
import { DateLocaleProvider } from "@/app/[lng]/_components/datelocale-context";
import { TRPCReactProvider } from "@/utils/trpc/react";

export function Providers({
  children,
  lng,
  cookies,
}: {
  children: React.ReactNode;
  lng: LocaleName;
  cookies?: [string, RequestCookie][];
}) {
  return (
    <TRPCReactProvider>
      <LocaleContext.Provider value={lng}>
        <DateLocaleProvider>
          <CookieProvider initialCookies={cookies}>
            <GoogleMapsProvider>
              <TooltipProvider>{children}</TooltipProvider>
            </GoogleMapsProvider>
          </CookieProvider>
        </DateLocaleProvider>
      </LocaleContext.Provider>
    </TRPCReactProvider>
  );
}
